const PbxxRecord = require('../../pbxx_record')

module.exports = class PulseLocation extends PbxxRecord {
  static get class_name() {
    return 'PulseLocation'
  }

  constructor(props, opts) {
    props.lat = parseFloat(props.latitude)
    props.lng = parseFloat(props.longitude)
    super(props, opts)
  }
}
